import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {useAppSelector} from '@/hooks';

export const PANEL_ID = 'social-accounts-connection-modal-panel';

interface SocialAccountConnectionProps {
  panelId?: string;
}

export default function SocialAccountsConnectionModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.SOCIAL_ACCOUNTS_CONNECTION_MODAL];
  });

  const height = 'auto';
  const width = '640px';

  return (
    <Modal modalId={MODALS_IDS.SOCIAL_ACCOUNTS_CONNECTION_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="social-accounts-connection-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openSocialAccountConnectionModal = (props: SocialAccountConnectionProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_ACCOUNTS_CONNECTION_MODAL,
      panelProps: props,
    })
  );
};
